import { createAction, props } from "@ngrx/store";

enum ACTIONS {
  OPEN = "[Header Component] open",
  CLOSE = "[Header Component] close",
  TOGGLE = "[Header Component] toggle",
}

export const open = createAction(ACTIONS.OPEN);
export const close = createAction(ACTIONS.CLOSE);
export const toggle = createAction(ACTIONS.TOGGLE);
